export type IconProps = React.HTMLAttributes<SVGElement>;

export const CaptainIcon = (props?: {
  fill?: string;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    className={props?.className}
  >
    <path
      d="M13.7219 7.42044L10.7645 7.37956H5.275L3.96351 5.11638L5.275 2.85612H13.6867L15.274 0.204552L10.9552 0.192871H3.73173L0.874023 5.11638L3.72586 10.034H15.2476L13.7219 7.42044Z"
      fill="white"
    />
  </svg>
);
